import React from 'react';
import DOMPurify from 'dompurify';
import Card from './ui/Card';
import { B } from '../constants';
import { getTripImageByDestination } from '../lib/tripImages';

export default function BlogRenderer({ content, experiences = [] }) {
  if (!content) return null;

  const parts = content.split(/\[PHOTO_CARD:(\d+)\]/);

  const renderTextContent = (text, partIndex) => {
    if (!text.trim()) return null;

    const paragraphs = text.split('\n\n');

    return paragraphs.map((para, idx) => {
      if (!para.trim()) return null;

      if (para.startsWith('## ')) {
        const headingText = para.replace(/^##\s+/, '');
        return (
          <h2 key={`${partIndex}-${idx}`} style={{
            fontFamily: "'Playfair Display',serif",
            fontSize: 28,
            fontWeight: 700,
            color: B.night,
            marginTop: 32,
            marginBottom: 16,
          }}>
            {headingText}
          </h2>
        );
      }

      return (
        <p key={`${partIndex}-${idx}`} style={{
          lineHeight: 1.8,
          fontSize: 16,
          color: B.night,
          marginBottom: 16,
        }}>
          <span dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(para
              .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
              .replace(/\*(.*?)\*/g, '<em>$1</em>'),
            ),
          }} />
        </p>
      );
    });
  };

  const renderPhotoCard = (experienceId) => {
    const exp = experiences.find(e => e.id === parseInt(experienceId, 10));
    if (!exp || !exp.photos?.length) return null;

    const photo = exp.photos[0];

    return (
      <Card
        variant="elevated"
        style={{ margin: '24px 0' }}
      >
        {photo.url && (
          <img
            src={photo.url}
            alt={exp.title}
            style={{
              width: '100%',
              height: 300,
              objectFit: 'cover',
              borderRadius: '12px 12px 0 0',
            }}
            onError={(e) => {
              const img = e.currentTarget;
              if (img.dataset.fallback) return;
              img.dataset.fallback = '1';
              img.src = getTripImageByDestination(exp.location || exp.title || '');
            }}
          />
        )}
        <div style={{ padding: 20 }}>
          <h3 style={{
            fontFamily: "'Playfair Display',serif",
            fontSize: 20,
            fontWeight: 700,
            color: B.night,
            marginBottom: 8,
          }}>
            {exp.title}
          </h3>
          {exp.location && (
            <p style={{ fontSize: 14, color: B.muted, marginBottom: 8 }}>
              📍 {exp.location}
            </p>
          )}
          {exp.rating && (
            <div style={{ fontSize: 14, color: '#f59e0b', marginBottom: 8 }}>
              {'★'.repeat(Math.round(exp.rating))}{'☆'.repeat(5 - Math.round(exp.rating))}
            </div>
          )}
          {exp.content && (
            <p style={{ fontSize: 14, color: B.night, lineHeight: 1.6 }}>
              {exp.content}
            </p>
          )}
        </div>
      </Card>
    );
  };

  return (
    <div>
      {parts.map((part, idx) => {
        if (idx % 2 === 0) {
          return renderTextContent(part, idx);
        } else {
          return renderPhotoCard(part);
        }
      })}
    </div>
  );
}
